// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUpGreatWorkStep_container__3tINJ","title":"SignUpGreatWorkStep_title__3UbzA","image":"SignUpGreatWorkStep_image__xT2dW"};